import { render } from "./Texttemplates.vue?vue&type=template&id=f8210820"
import script from "./Texttemplates.vue?vue&type=script&lang=js"
export * from "./Texttemplates.vue?vue&type=script&lang=js"

import "./Texttemplates.vue?vue&type=style&index=0&id=f8210820&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__